import { useMutation, useQueryClient } from 'react-query';

import type { RefundAccountRequestV2 } from '~/api/data-source/refund';
import { REFUND_QUERY_KEY } from '~/api/query-keys';

import { refundRepository } from '../repository';

// PUT /api/market-place/v2/payments/refund-account
export const useUpdateRefundAccount = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateRefundAccount } = useMutation({
    mutationFn: (data: RefundAccountRequestV2) =>
      refundRepository.updateRefundAccount(data),
    onSuccess: () => {
      void queryClient.invalidateQueries(REFUND_QUERY_KEY.all);
    },
  });

  return updateRefundAccount;
};
